import { SUFFIX_DOMAIN } from "@/config/constants";
import { LISTENER_KEYS } from "@/config/listener-keys";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { Loader } from "rizzui";

export default function XeroConnectConfirmation() {
  const location = useLocation();
  const firstCallback = React.useRef(false);

  React.useEffect(() => {
    if (!window) return;
    // Just send the message once
    if (firstCallback.current) return;

    const originDomain = `https://admin${SUFFIX_DOMAIN}`;

    if (window.opener) {
      firstCallback.current = true;

      window.opener.postMessage(
        { type: LISTENER_KEYS.XERO_CALLBACK, data: location.search },
        originDomain
      );

      // Close this popup window
      window.close();
    }
  }, [location.search]);

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-2">
      <Loader />

      <p className="text-sm text-gray-500">Verifying your Xero account...</p>
    </div>
  );
}
